export enum RenderLayer {
	Background = 0,
	Dimension = 100,
	Action = 200,
	ActionMenu = 250,
	Tooltip = 300,
	Overlay = 400
}
